<template>

  <div id="claudiademedio">
    <Header/>
    <transition name="fade">
      <router-view/>
    </transition>
    <Footer/>
  </div>

</template>

<script>

  // @ is an alias to /src
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'

  export default {
    components: {
      Header,
      Footer
    },
    methods: {
      scrollToTop() {
        document.body.scrollIntoView()
      }
    },
    mounted(){
      this.scrollToTop()
    }
  }

</script>

<style lang="scss">

  @import '@/scss/app.scss';

  // .fade-enter-active, .fade-leave-active {
  //   transition: opacity .4s;
  // }
  // .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  //   opacity: 0;
  // }

</style>
